var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2879 9.16675H2.21214C1.26655 9.16675 0.5 9.93831 0.5 10.8901V11.1101C0.5 12.0619 1.26655 12.8334 2.21214 12.8334H24.2879C25.2334 12.8334 26 12.0619 26 11.1101V10.8901C26 9.93831 25.2334 9.16675 24.2879 9.16675Z",
    fill: "#94999E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2879 18.3333H2.21214C1.26655 18.3333 0.5 19.1048 0.5 20.0566V20.2766C0.5 21.2284 1.26655 21.9999 2.21214 21.9999H24.2879C25.2334 21.9999 26 21.2284 26 20.2766V20.0566C26 19.1048 25.2334 18.3333 24.2879 18.3333Z",
    fill: "#94999E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2879 0H2.21214C1.26655 0 0.5 0.771563 0.5 1.72333V1.94333C0.5 2.8951 1.26655 3.66667 2.21214 3.66667H24.2879C25.2334 3.66667 26 2.8951 26 1.94333V1.72333C26 0.771563 25.2334 0 24.2879 0Z",
    fill: "#94999E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBar);
export default __webpack_public_path__ + "static/media/darkBar.2ca836c9ece6231bb429e048ce453e65.svg";
export { ForwardRef as ReactComponent };